<template>
  <div id="tabArrivalInformation">
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form label-width="150px" label-position="right" :disabled="readonly">
            <span class="title">{{ $t('SeaExport.PodPortInfo') }}</span>
            <!-- 预计到港时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedArrivalTime')">
              <el-date-picker
                v-model="form.estimatedArrivalTime"
                no="1"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际到港时间 -->
            <el-form-item :label="$t('SeaExport.ArrivalTime')">
              <el-date-picker
                v-model="form.actualArrivalTime"
                no="2"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计卸船时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedPortDischargeTime')">
              <el-date-picker
                v-model="form.estimatedPortDischargeTime"
                no="3"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际卸船时间 -->
            <el-form-item :label="$t('SeaExport.PortDischargeTime')">
              <el-date-picker
                v-model="form.portDischargeTime"
                no="4"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计铁路运输时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedRailwayDepartureTime')">
              <el-date-picker
                v-model="form.estimatedRailwayDepartureTime"
                no="estimatedRailwayDepartureTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际铁路运输时间 -->
            <el-form-item :label="$t('SeaExport.RailwayDepartureTime')">
              <el-date-picker
                v-model="form.railwayDepartureTime"
                no="5"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计铁路卸货时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedRailwayDischargeTime')">
              <el-date-picker
                v-model="form.estimatedRailwayDischargeTime"
                no="6"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际铁路卸货时间 -->
            <el-form-item :label="$t('SeaExport.RailwayDischargeTime')">
              <el-date-picker
                v-model="form.railwayDischargeTime"
                no="7"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计抵达交货地时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedTimeOfArrivalAtThePlaceOfDelivery')">
              <el-date-picker
                v-model="form.estimatedArrivalPlaceOfDelivery"
                no="8"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际抵达交货地时间 -->
            <el-form-item :label="$t('SeaExport.TheActualTimeOfArrivalAtThePlaceOfDelivery')">
              <el-date-picker
                v-model="form.actualArrivalPlaceOfDelivery"
                no="9"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计放关时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedCustomsReleaseTime')">
              <el-date-picker
                v-model="form.estimatedCustomsReleaseTime"
                no="10"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际放关时间 -->
            <el-form-item :label="$t('SeaExport.ActualCustomsReleaseTime')">
              <el-date-picker
                v-model="form.destPortCustomsClearanceTime"
                no="11"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计提重时间 -->
            <el-form-item :title="$t('SeaExport.PickupMessage')" :label="$t('SeaExport.EstimatedPickupTime')">
              <el-date-picker
                v-model="form.estimatedPickUpTime"
                no="12"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际提重时间 -->
            <el-form-item :title="$t('SeaExport.PickupMessage')" :label="$t('SeaExport.ActualPickUpTime')">
              <el-date-picker
                v-model="form.actualPickUpTime"
                no="13"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form label-width="110px" label-position="right" :disabled="readonly">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.estimatedDeliveryToWarehouseTime"
                no="14"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.deliveryTime"
                no="15"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.destPortDeliveryTime"
                no="16"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.deliveryCompletionDate"
                no="17"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计还空时间 -->
            <el-form-item :label="$t('SeaExport.EstimatedReturnTime')">
              <el-date-picker
                v-model="form.estimatedReturnTime"
                no="20"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际还空时间 -->
            <el-form-item :label="$t('SeaExport.ActualReturnTime')">
              <el-date-picker
                v-model="form.destPortReturnTime"
                no="21"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'

export default {
  name: 'TabArrivalInformation',
  components: {
  },
  props: {
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: new SeaImportJob().fillDefaultValue().getData()
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row
      }
    },
    getSubmitData() {
      this.validateForm()
      const job = { ...this.form }
      return {
        job
      }
    },
    validateForm() {
      // UI自定义中用到
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
